<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => toggleSidebar(val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ titleForm }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Institución"
            rules="required"
          >
            <b-form-group
              label="Institución"
              label-for="institucion"
              :state="getValidationState(validationContext)"
            >
              <b-form-select
                v-model="institucion"
                type="select"
                class="custom-select"
              >
                <option value="">
                  SELECCIONE::
                </option>
                <option
                  v-for="inst in optionInstitucion"
                  :key="inst.idInstitucion"
                  :value="inst.idInstitucion"
                >
                  {{ inst.nombre }}
                </option>
              </b-form-select>
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Nombre"
            rules="required"
          >
            <b-form-group
              label="Nombre"
              label-for="nombre"
            >
              <b-form-input
                id="nombre"
                v-model="formData.nombre"
                :state="getValidationState(validationContext)"
                trim
                placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Abreviatura"
            rules="required"
          >
            <b-form-group
              label="Abreviatura"
              label-for="abreviatura"
            >
              <b-form-input
                id="abreviatura"
                v-model="formData.abreviatura"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="NombreResponsable"
            rules="required"
          >
            <b-form-group
              label="Nombre Responsable"
              label-for="nombreResponsable"
            >
              <b-form-input
                id="nombreResponsable"
                v-model="formData.nombreResponsable"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group
            v-show="false"
            label="Longitud"
            label-for="longitud"
          >
            <b-form-input
              id="longitud"
              v-model="formData.longitud"
              trim
            />
          </b-form-group>
          <b-form-group
            v-show="false"
            label="Latitud"
            label-for="latitud"
          >
            <b-form-input
              id="latitud"
              v-model="formData.latitud"
              autofocus
              trim
              placeholder=""
            />
          </b-form-group>
          <b-row class="container">
            <b-col md="4">
              <b-media class="mb-2 text-center">
                <template #aside>
                  <b-avatar
                    ref="previewEl"
                    :src="imgBase64"
                    :text="avatarText(imgBase64)"
                    size="100px"
                    rounded=""
                  />
                </template>
              </b-media>
            </b-col>
            <b-col md="8">
              <b-row class="mt-1">
                <b-col md="12">
                  <b-button
                    variant="success"
                    class="btn-block btn-sm"
                    @click="$refs.refInputEl.$el.click()"
                  >
                    <b-form-file
                      id="file"
                      ref="refInputEl"
                      v-model="fileLogo"
                      accept=".jpg, .png, .gif"
                      :hidden="true"
                      plain
                      @input="inputImageRenderer"
                      @change="uploadFile"
                    />
                    <!-- <input
                      id="file"
                      ref="refInputEl"
                      type="file"
                      v-model="fileLogo"
                      class="d-none"
                      @input="inputImageRenderer"
                      v-on:change="uploadFile"
                    > -->
                    <span class="d-none d-sm-inline">Subir Imagen</span>
                    <feather-icon
                      icon="EditIcon"
                      class="d-inline d-sm-none"
                    />
                  </b-button>
                </b-col>
              </b-row>
              <b-row style="padding-top:10px">
                <b-col md="12">
                  <b-button
                    variant="danger"
                    class="btn-block btn-sm"
                    @click="onDeleteImagen"
                  >
                    <span class="d-none d-sm-inline">Eliminar Imagen</span>
                    <feather-icon
                      icon="TrashIcon"
                      class="d-inline d-sm-none"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <div class="d-flex mt-3">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="isBusy"
            >
              Guardar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormSelect, BMedia, BAvatar, BRow, BCol, BFormFile,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import { avatarText } from '@core/utils/filter'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import store from '@/store'
import { useNotify } from '@/helpers/toast'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormSelect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormFile,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
    formType: {
      type: String,
      required: true,
    },
    imgLogo: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      required,
      avatarText,
    }
  },
  setup(props, context) {
    // const { resolveUserRoleVariant } = useUsersList()
    const { notify } = useNotify(context)
    const optionInstitucion = ref('')
    const departamento = ref('')
    const institucion = ref('')
    const titleForm = ref('')
    const fileLogo = ref(null)
    const imgBase64 = ref(null)
    const refInputEl = ref(null)
    const previewEl = ref(null)
    const isBusy = ref(false)
    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      // eslint-disable-next-line no-param-reassign
      imgBase64.value = base64
      // props.imgLogo = base64
    })

    const blankData = {
      nombre: '',
      abreviatura: '',
      nombreResponsable: '',
      longitud: '',
      latitud: '',
      logo: null,
      idProyecto: 0,
    }
    const blankSelect = ''
    const formData = ref(JSON.parse(JSON.stringify(blankData)))/* desestructuracion de  blankData */
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
      institucion.value = JSON.parse(JSON.stringify(blankSelect))
    }

    const onDeleteImagen = () => {
      imgBase64.value = null
    }
    const uploadFile = e => {
      const fileTemp = e.target.files[0]
      fileLogo.value = fileTemp
    }
    const onSubmit = () => {
      isBusy.value = true
      // let bval = true
      formData.value.institucion = {
        idInstitucion: institucion.value,
      }
      formData.value.logo = (fileLogo.value !== null) ? fileLogo.value : null
      /* if (formData.value.logo === null) {
        isBusy.value = false
        notify('Advertencia', 'Es necesario adjuntar logo', 'warning')
        bval = false
      } */
      // if (bval) {
      let service = 'gsencuesta/PROYECTO_CREATE'
      if (props.formType === 'edit') {
        service = 'gsencuesta/PROYECTO_UPDATE'
      }
      store.dispatch(service, formData.value)
        .then(response => {
          isBusy.value = false
          context.emit('refetch-data', response)
          context.emit('update:is-add-new-user-sidebar-active', false)
        })
        .catch(error => {
          isBusy.value = false
          context.emit('error-data', error)
          // context.emit('update:is-add-new-user-sidebar-active', false)
        })
      fileLogo.value = null
      document.getElementById('file').value = ''
      // }
    }
    const dataForm = () => {
      store
        .dispatch('gsencuesta/INSTITUCION_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
          // estado
        })
        .then(response => {
          if (response !== undefined) {
            optionInstitucion.value = response
          }
        })
        .catch(error => {
          notify(error, 'He ocurrido un error', 'danger')
        })
    }
    const getLogo = data => {
      store
        .dispatch('gsencuesta/PROYECTO_FIND_LOGO', {
          idProyecto: data.idProyecto,
        })
        .then(response => {
          imgBase64.value = `data:image/png;base64,${Buffer.from(response, 'binary').toString('base64')}`
        })
        .catch(error => {
          notify(error, 'He ocurrido un error', 'danger')
        })
    }
    const toggleSidebar = val => {
      dataForm()
      context.emit('update:is-add-new-user-sidebar-active', val)
      institucion.value = ''
      imgBase64.value = null /* INICIALIZANDO LOGO */
      fileLogo.value = null
      document.getElementById('file').value = ''

      if (props.formType === 'new') {
        titleForm.value = 'Agregar Dependencia'
      }
      if (props.formType === 'edit') {
        formData.value = {
          idProyecto: props.dataEdit.idProyecto,
          nombre: props.dataEdit.nombre,
          abreviatura: props.dataEdit.abreviatura,
          nombreResponsable: props.dataEdit.nombreResponsable,
          longitud: props.dataEdit.longitud,
          latitud: props.dataEdit.latitud,
          logo: (props.dataEdit.logo) ? props.dataEdit.logo : null,
        }
        getLogo(props.dataEdit)
        institucion.value = props.dataEdit.institucion.idInstitucion
        titleForm.value = 'Editar Dedenencia'
      }
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      formData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      institucion,
      fileLogo,
      refInputEl, // PARA RELACIONAR BOTON CON INPUT FILE
      inputImageRenderer,
      previewEl,
      imgBase64,
      onDeleteImagen,
      uploadFile,
      toggleSidebar,
      departamento,
      optionInstitucion,
      titleForm,
      isBusy,
      // resolveUserRoleVariant,
    }
  },
  methods: {
    openLogo(item) {
      if (item.logo) {
        window.open(item.logo)
      } else {
        this.$bvToast.toast('Error', {
          title: 'He ocurrido un error',
          variant: 'danger',
          solid: true,
        })
      }
    },
    formatNames(files) {
      return (files.length === 1) ? files[0].name : `${files.length} archivos seleccionados`
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
